import { heroImage } from '../data/copy'

const TITLE =
  'Megapack Atletismo 360 — 6 volúmenes y +70 sesiones listas para entrenadores'
const DESCRIPTION =
  'El sistema completo de entrenamiento de atletismo en español: 6 volúmenes técnicos, +70 sesiones listas para usar y 5 bonos. Planificá tu entrenamiento en 5 minutos.'

const FONTS_HREF =
  'https://fonts.googleapis.com/css2?family=Bodoni+Moda:opsz,wght@6..96,500;6..96,700&family=Inter:wght@400;500;600;700&display=swap'

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  )
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.content = content
}

function appendLink(attrs: Record<string, string>): HTMLLinkElement {
  const link = document.createElement('link')
  Object.entries(attrs).forEach(([key, value]) => link.setAttribute(key, value))
  document.head.appendChild(link)
  return link
}

/**
 * Prepara el <head> antes del primer render:
 *
 * - idioma, título y metadatos sociales (SEO / compartir);
 * - precarga de la imagen del hero, que es el elemento LCP;
 * - carga de las tipografías SIN bloquear el renderizado (media="print" y
 *   luego media="all" al terminar de descargar).
 */
export function setupHead(): void {
  if (typeof document === 'undefined') return

  document.documentElement.lang = 'es'
  document.title = TITLE

  upsertMeta('name', 'description', DESCRIPTION)
  upsertMeta('name', 'theme-color', '#0B0C0F')
  upsertMeta('property', 'og:type', 'website')
  upsertMeta('property', 'og:title', TITLE)
  upsertMeta('property', 'og:description', DESCRIPTION)
  upsertMeta('property', 'og:image', heroImage)
  upsertMeta('name', 'twitter:card', 'summary_large_image')
  upsertMeta('name', 'twitter:title', TITLE)
  upsertMeta('name', 'twitter:description', DESCRIPTION)
  upsertMeta('name', 'twitter:image', heroImage)

  if (document.head.querySelector('link[data-mp-head]')) return

  // Conexión anticipada al CDN de imágenes: ahorra DNS + TLS antes del LCP.
  appendLink({
    rel: 'preconnect',
    href: 'https://cdn.magicpatterns.com',
    crossorigin: '',
    'data-mp-head': 'cdn',
  })

  // La imagen del hero es el LCP: empieza a descargarse antes de que React monte.
  appendLink({
    rel: 'preload',
    as: 'image',
    href: heroImage,
    fetchpriority: 'high',
    'data-mp-head': 'hero',
  })

  appendLink({
    rel: 'preconnect',
    href: 'https://fonts.googleapis.com',
    'data-mp-head': 'fonts',
  })
  appendLink({
    rel: 'preconnect',
    href: 'https://fonts.gstatic.com',
    crossorigin: '',
    'data-mp-head': 'fonts',
  })

  const fonts = appendLink({
    rel: 'stylesheet',
    href: FONTS_HREF,
    media: 'print',
    'data-mp-head': 'fonts',
  })
  fonts.addEventListener('load', () => {
    fonts.media = 'all'
  })
}
